'use client';
import { SportMatchModel } from '@nf/types/odds';
import { SymbolGvIcon, SymbolStreamerIcon, SymbolVideoIcon } from '@/components/icons/symbol-icon';
import { streamingService } from '@/services/streaming.service';
import { useAccountInfo } from '@/hooks/query/account';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAuthToken } from '@/store/auth';
import { useSlmtGv } from '@/hooks/query/use-slmt-gv';
import { useParams } from 'next/navigation';

export const MatchLiveStreaming = ({ match }: { match: SportMatchModel }) => {
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const authToken = useAuthToken();
	const isBefore = !Boolean(authToken);
	const { sport } = useParams();
	const { hasSlmtGv } = useSlmtGv({ match, sport });
	const { hasVideo, hasGV, hasStreamer, hasLSports } = streamingService.getVideoOptions(match, false, SiteConfigsData, user);
	return (
		!isBefore &&
			<>
				{hasVideo && <SymbolVideoIcon />}
				{/* {hasLSports && <SymbolGvIcon />} */}
				{hasSlmtGv && <SymbolGvIcon />}
				{Boolean(hasStreamer) && <SymbolStreamerIcon />}
			</>	
	);
};
